import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import CardCapture from './CardCapture';
import './RegisterClub.css';

function SignupFund() {
  const [searchParams] = useSearchParams();
  const clubId = searchParams.get('clubId');
  const navigate = useNavigate();
  const [cardSaved, setCardSaved] = useState(false);

  const handleCardSuccess = () => {
    setCardSaved(true);
  };

  const handleFinish = () => {
    navigate(`/dashboard/${clubId}`);
  };

  const handleSkip = () => {
    navigate(`/dashboard/${clubId}`);
  };

  return (
    <div className="register-club-wrapper">
      <div className="register-club-container-dark">
        <div className="register-club-logo">
          <img src="/logo.png" alt="Punt Club Logo" />
        </div>

        <h2 className="register-club-title">Fund Your Club</h2>
        <p className="register-club-subtitle">
          Add a payment card so your contributions are automatically collected.
        </p>

        {/* Progress */}
        <div className="progress-steps" style={{ marginBottom: '1.5rem' }}>
          {['Register', 'Create Club', 'Link Bookie', 'Invite Mates', 'Fund Club'].map((s, i) => (
            <div key={i} className={`progress-step ${i === 4 ? 'active' : 'completed'}`}>
              <div className="step-number">{i + 1}</div>
              <div className="step-info"><div className="step-title">{s}</div></div>
            </div>
          ))}
        </div>

        {cardSaved ? (
          <div>
            <div className="success-message" style={{ marginBottom: '1.5rem' }}>
              Card saved successfully! Your contributions will be automatically collected.
            </div>
            <button onClick={handleFinish} className="btn-warning" style={{ width: '100%' }}>
              Go to Your Club Dashboard
            </button>
          </div>
        ) : (
          <div>
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '12px', padding: '1.5rem', marginBottom: '1rem' }}>
              <CardCapture
                clubId={clubId}
                onSuccess={handleCardSuccess}
                onError={() => {}}
              />
            </div>

            <div style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: '8px', padding: '0.75rem', marginBottom: '1.5rem' }}>
              <p style={{ color: '#10b981', fontSize: '0.8rem', margin: 0 }}>
                Your card details are securely stored by PCI Vault. Punt Club never sees your card number.
              </p>
            </div>

            <button onClick={handleFinish} className="btn-warning" style={{ width: '100%', marginBottom: '0.5rem' }}>
              {cardSaved ? 'Go to Dashboard' : 'Continue Without Card'}
            </button>

            <div className="skip-link">
              <a href="#" onClick={e => { e.preventDefault(); handleSkip(); }}>
                Skip — I'll add a card later
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SignupFund;
